/*       */

import Immutable from 'app/utils/immutable/Immutable';
import { dataTableReducer, keepDataAtStart, loadDataReducer } from 'app/utils/redux/reducer-utils';
import {
    LOAD_COLUMNS_TASKS_STARTED,
    LOAD_COLUMNS_TASKS,
    LOAD_BOARD_COLUMNS_STARTED,
    LOAD_BOARD_COLUMNS,
    LOAD_ALL_COLUMNS_STARTED,
    LOAD_ALL_COLUMNS,
    SET_SELECTED_BOARD,
    COLUMN_ORDER_POSITION,
    LOAD_BOARD_PRIMARY_CLASS_STARTED,
    LOAD_BOARD_PRIMARY_CLASS,
    LOAD_BOARD_RECORDS_ALL_STARTED,
    LOAD_BOARD_RECORDS_ALL,
    LOAD_BOARD_RECORDS_BY_COLUMN_STARTED,
    LOAD_BOARD_RECORDS_BY_COLUMN,
} from 'store/actions/abox/boardActions';
import { combineReducers } from 'redux';
import { isEmpty } from 'app/utils/utils';
import { get } from 'app/utils/lo/lo';

const initialState = {
    boardColumns: {
        records: [],
        isReordered: false,
        isAdded: false,
        isRemoved: false,
        isLoading: false,
    },
    selectedBoard: null,
};


const initialPagedState = {
    records: [],
    count: 0,
    page: 0,
    pageSize: 0,
    isLoading: false,
    isDownloading: false,
};

const boardRecordsAllReducer = (state = initialPagedState, action) => {
    const { type, payload, meta = {}, error } = action || {};

    switch (type) {

        case SET_SELECTED_BOARD: {
            // Clear data when board changes
            return initialPagedState;
        }

        case LOAD_BOARD_RECORDS_ALL_STARTED: {
            const shouldReset =
                meta.startIndex === 0 || meta.page === 1 || meta.reset;

            const baseState = shouldReset ? initialPagedState : state;

            return {
                ...baseState,
                isLoading: true,
            };
        }

        case LOAD_BOARD_RECORDS_ALL: {
            if (error) {
                return {
                    ...state,
                    isLoading: false,
                };
            }

            const { records = [], count = 0 } = payload || {};
            return {
                ...state,
                records: [...(state.records || []), ...records],
                count,
                page: meta.page,
                pageSize: meta.pageSize,
                isLoading: false,
            };
        }

        default:
            return state;
    }
};

const boardsReducerMain = (state = initialState, action) => {
    const { type, payload } = action || {};
    switch (type) {
        case SET_SELECTED_BOARD:
            return Immutable({ ...state, selectedBoard: payload });

        case LOAD_BOARD_COLUMNS_STARTED:
            return Immutable({
                ...state,
                boardColumns: {
                    ...state.boardColumns,
                    isReordered: false,
                    isRemoved: false,
                    isAdded: false,
                    isLoading: true,
                },
            });

        case LOAD_BOARD_COLUMNS:
            const parsedPayload = {
                ...state.boardColumns,
                ...payload,
                records: !payload.records
                    ? []
                    : payload.records
                        .map((record, index) => {
                            const attributes = get(record, 'relation.attributes');
                            const order = !isEmpty(attributes) ? attributes['board-board-label/order'] : index + 1;
                            return {
                                relationId: record.relation.id,
                                isAdded: false,
                                order: order,
                                ...record.relatedEntity,
                            };
                        })
                        .sort((a, b) => a.order - b.order),
            };
            return Immutable({ ...state, boardColumns: { ...parsedPayload, isLoading: false } });

        case COLUMN_ORDER_POSITION:
            return Immutable({
                ...state,
                boardColumns: {
                    ...state.boardColumns,
                    isReordered: true,
                    isAdded: false,
                    isRemoved: false,
                    records: payload,
                },
            });
        default:
            return state;
    }
};

const initialColumnState = {
    records: {},
    isLoading: false
};

const boardRecordsByColumn = (state = initialColumnState, action) => {
    const { type, payload, error } = action || {};

    switch (type) {

        case SET_SELECTED_BOARD: {
            // Clear data when board changes
            return initialColumnState;
        }

        case LOAD_BOARD_RECORDS_BY_COLUMN_STARTED: {
            return {
                ...state,
                isLoading: true
            };
        }

        case LOAD_BOARD_RECORDS_BY_COLUMN: {

            if (error) {
                return {
                    ...state,
                    isLoading: false
                };
            }
            if (payload.mode === 'bulk') {
                return {
                    ...state,
                    records: {
                        ...payload.data
                    },
                    isLoading: false
                };
            }

            if (payload.mode === 'single') {
                const { columnId, records, count, page, pageSize, columnFilter } = payload;

                const prev = state.records[columnId] || {
                    records: [],
                    page: 0,
                    count: 0,
                    pageSize: 500
                };

                return {
                    ...state,
                    records: {
                        ...state.records,
                        [columnId]: {
                            ...prev,
                            records: [...prev.records, ...records],
                            page,
                            count,
                            pageSize: pageSize || prev.pageSize,
                            columnFilter: columnFilter || prev.columnFilter // Save filter
                        }
                    },
                    isLoading: false
                };
            }

            return state;
        }


        default:
            return state;
    }
};


const taskReducer = combineReducers({
    boardRecordsByColumn: boardRecordsByColumn,
    boardRecordsAll: boardRecordsAllReducer,
    primaryClass: loadDataReducer(LOAD_BOARD_PRIMARY_CLASS_STARTED, LOAD_BOARD_PRIMARY_CLASS, keepDataAtStart),
    tasks: dataTableReducer(LOAD_COLUMNS_TASKS_STARTED, LOAD_COLUMNS_TASKS, keepDataAtStart),
    allColumns: dataTableReducer(LOAD_ALL_COLUMNS_STARTED, LOAD_ALL_COLUMNS, keepDataAtStart),
    boardsOption: boardsReducerMain,
});
export default taskReducer;
